module.exports = __webpack_public_path__ + "static/img/sm.8a29812f.svg";